import handleSharingInformation from '../../utils/sharingTips/handleSharingInformation';
import AttachmentWellViewState from '../../schema/AttachmentWellViewState';
import removeAttachmentFromWell from '../removeAttachmentFromWell';
import updateChangeKeyOnItemId from '../updateChangeKeyOnItemId';
import { ClientItemId } from 'owa-client-ids';
import { ClientAttachmentId } from 'owa-client-ids';
import { lazyUnsubscribe, NotificationSubscription } from 'owa-notification';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import {
    AttachmentState,
    AttachmentStateType,
    InlineAttachmentState,
    InlineAttachmentStatus,
    setInlineAttachmentStatus,
    updateAttachment,
} from 'owa-attachment-full-data';

export function onAttachmentCreationSuccess(
    attachmentState: AttachmentState,
    attachmentInClientId: ClientAttachmentId,
    attachmentInClient: AttachmentType,
    attachmentFromServer: AttachmentType,
    parentItemId: ClientItemId,
    sharingInfoResponse: GetSharingInfoResponse
): void {
    // 1. Update the attachment in store with the one from server
    // 2. Update the attachmentId in attachmentViewState
    // 3. Initialize attachment policy
    updateAttachment(
        attachmentState,
        attachmentInClientId,
        attachmentInClient,
        attachmentFromServer,
        sharingInfoResponse
    );

    // Update the changeKey
    updateChangeKeyOnItemId(parentItemId, attachmentFromServer.AttachmentId.RootItemChangeKey);

    handleSharingInformation(attachmentState, attachmentInClient, sharingInfoResponse);
}

export function onAttachmentCreationError(
    attachment: AttachmentState,
    attachmentWell?: AttachmentWellViewState,
    subscription?: NotificationSubscription,
    notificationHandler?: (notification: NotificationPayloadBase) => void
): void {
    if (attachment.attachmentType === AttachmentStateType.InlineAttachment) {
        // It's important that this is called before removeAttachmentFromWell
        // so that placeholder can be cleared in compose.
        setInlineAttachmentStatus(
            <InlineAttachmentState>attachment,
            InlineAttachmentStatus.CreateAttachmentFailed
        );
    }

    if (attachmentWell) {
        removeAttachmentFromWell(attachmentWell, attachment);
    }

    if (subscription && notificationHandler) {
        lazyUnsubscribe.importAndExecute(subscription, notificationHandler);
    }
}
